import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Option } from "@shared/Entities/General/option.entity";
import { CompanyAlly } from "@shared/Interfaces/company-ally.interface";
import { PadronPerson } from "@shared/Interfaces/person";

import { SharedOptionsRepository } from "../Repositories/shared-options.repository";

@Injectable({
  providedIn: "root",
})
export class SharedOptionsService {
  constructor(private sharedOptionsRepository: SharedOptionsRepository) {}

  public getSexs(): Observable<Option[]> {
    return this.sharedOptionsRepository.getSexs();
  }

  public getMaritalStatus(): Observable<Option[]> {
    return this.sharedOptionsRepository.getMaritalStatus();
  }

  public getPersonByIdentification(identification: string): Observable<PadronPerson> {
    return this.sharedOptionsRepository.getPersonByIdentification(identification);
  }

  public getIdentificationTypes(): Observable<Option[]> {
    return this.sharedOptionsRepository.getIdentificationTypes();
  }

  public getProvinces(): Observable<Option[]> {
    return this.sharedOptionsRepository.getProvinces();
  }

  public getCompanyAlly(): Observable<CompanyAlly[]> {
    return this.sharedOptionsRepository.getCompanyAlly();
  }
}
